import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { mediaFilter } from '../../utils/image';
import { AnuncioI } from '../../models/home';

interface SortableAnuncioItemProps {
  anuncio: AnuncioI;
  index: number;
  onRemove: (index: number) => void;
  onUrlChange?: (index: number, url: string) => void;
}

const SortableAnuncioItem: React.FC<SortableAnuncioItemProps> = ({
  anuncio,
  index,
  onRemove,
  onUrlChange,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: anuncio.orden });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    display: 'flex',
    flexDirection: 'column' as const,
    marginBottom: 20,
    gap: 10,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      {...attributes}
    >
      {/* Solo la imagen y el orden son arrastrables */}
      <div
        {...listeners}
        role="button"
        tabIndex={0}
        style={{ cursor: 'grab', touchAction: 'none', userSelect: 'none' }}
      >
        <img
          src={
            anuncio.imagen?.startsWith('blob:')
              ? anuncio.imagen
              : mediaFilter({ path: anuncio.imagen })
          }
          alt={`preview-${index}`}
          className="w-[140px] h-[110px] object-cover mx-auto"
          draggable={false}
        />
        <p style={{ textAlign: 'center', fontSize: 12, userSelect: 'none' }}>Orden: {anuncio.orden}</p>
      </div>

      <input
        type="text"
        placeholder="URL del anuncio"
        value={anuncio.url || ''}
        onChange={(e) => onUrlChange?.(index, e.target.value)}
        style={{
          padding: '8px',
          borderRadius: '4px',
          border: '1px solid #ccc',
          fontSize: '12px',
          width: '100%',
        }}
      />

      <button type='button' onClick={() => onRemove(index)}>Eliminar</button>
    </div>
  );
};

export default SortableAnuncioItem;
